import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LogoutOutlined } from '../icons';
import './LogoutButton.css';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // O cookie é httpOnly — só o backend consegue limpá-lo.
      await axios.post(`${process.env.REACT_APP_API_URL}logout`);
    } catch (error) {
      // Segue limpando o estado local mesmo se a chamada falhar (ex.: sem rede).
    }
    localStorage.removeItem('userId');
    localStorage.removeItem('csrfToken');
    localStorage.removeItem('trialFlowCompleted');
    navigate('/');
  };

  return (
    <button
      type="button"
      className="logout-button"
      onClick={handleLogout}
      aria-label="Sair da conta"
      title="Sair da conta"
    >
      <LogoutOutlined style={{ fontSize: 20 }} />
    </button>
  );
};

export default LogoutButton;
